import { LayoutDashboard } from "lucide-react";
import { useAppSelector } from "@/stores/hook";

/**
 * Primary-dashboard title for the GLOBAL app header (rendered in the otherwise
 * blank left slot, beside the quick-search box). v2 is now the only dashboard,
 * so this always renders on the dashboard route.
 */
function greetingFor(hour: number): string {
  if (hour < 12) return "Good morning";
  if (hour < 17) return "Good afternoon";
  return "Good evening";
}

export default function DashboardV2HeaderTitle() {
  const user = useAppSelector((state) => state.auth.currentUser?.user);

  const firstName = (user?.name ?? "").trim().split(/\s+/)[0] || "there";
  const now = new Date();
  const greeting = greetingFor(now.getHours());
  const dateLabel = now.toLocaleDateString(undefined, {
    weekday: "long",
    day: "numeric",
    month: "long",
  });

  return (
    <div className="flex items-center gap-3 min-w-0">
      <div className="flex size-9 shrink-0 items-center justify-center rounded-xl border border-[#d6ebe3] bg-[#218760]/10">
        <LayoutDashboard className="size-5 text-[#218760]" />
      </div>
      <div className="min-w-0">
        <p className="truncate text-[15px] font-medium tracking-[-0.3px] text-[#1e302a]">
          {greeting}, {firstName}
        </p>
        <p className="truncate text-[11px] font-normal tracking-[-0.22px] text-[#697571]">
          {dateLabel}
        </p>
      </div>
    </div>
  );
}
